export default "__VITE_ASSET__24353b2b__"